/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import ActionCreator from '../action-creator';

export const ActionCreators = {
  RequestSteerableBeams: new ActionCreator<'RequestSteerableBeams', any>('RequestSteerableBeams'),
  CancelRequestSteerableBeamsPoll: new ActionCreator<'CancelRequestSteerableBeamsPoll', any>(
    'CancelRequestSteerableBeamsPoll',
  ),
  ReceivedSteerableBeamsSuccess: new ActionCreator<'ReceivedSteerableBeamsSuccess', any>(
    'ReceivedSteerableBeamsSuccess',
  ),
  ReceivedSteerableBeamsError: new ActionCreator<'ReceivedSteerableBeamsError', any>('ReceivedSteerableBeamsError'),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function requestSteerableBeams() {
  return ActionCreators.RequestSteerableBeams.create();
}

export function cancelSteerableBeamsPoll() {
  return ActionCreators.CancelRequestSteerableBeamsPoll.create();
}
